const EventBus = window.EventBus;
export const ToggleListSort = {
  props: [
    'component',
    'prop-title',
    'items',
    'selected',
    'collapse',
    'pivot',
    'disable-responsive',
    'sort-condition',
    'prop-sort',
    'gutembergOpts',
  ],
  data: function () {
    return {
      show: false,
      checked: [],
      uniqueInList: null,
      theme_directory: window.theme_directory,
      title: this.propTitle,
      sort: this.propSort,
      displaySort: 'Select',
      order: {
        'price':'desc',
        'year':'desc',
        'numberofpics': 'desc'
      }
    }
  },
  mounted() {
    EventBus.$on('CLOSE_ALL_OPEN_COMPONENTS', () => {
      if (this.show)
        this.show = false
    });

    this.changeSortDisplay(this.sort.toLowerCase(), this.sortCondition.toLowerCase());

    if (this.gutembergOpts) {
      const sortBy = this.gutembergOpts.sort_by.toLowerCase();
      const sortByCondition = this.gutembergOpts.sort_by_condition.toLowerCase();
  
      if (sortBy && sortByCondition) {
        this.order[sortBy] = sortByCondition;
      }
    }
  },
  methods: {
    clear() {
      this.title = this.propTitle;
      this.sort = "";
    },
    sortByDynamic(field, title) {

      this.order[field] === 'asc' ? this.order[field] = 'desc' : this.order[field] = 'asc';

      let query = window.location.search || '';
      let pathnameClear = (window.location.pathname.replace(/\/?sort_order\/[a-zA-Z]+\//gi, '/')).replace(/\/?sort_by\/[a-zA-Z]+\//gi, '/');
      let finalUrl = `${pathnameClear}/sort_by/${field}/sort_order/${this.order[field]}/${query}`

      history.replaceState({}, null, finalUrl.replace('//', '/'));
      this.sort = "";
      this.title = title;
      EventBus.$emit('sortInventory', { field, order: this.order[field] });
      try {
        this.$parent.sendSignalToInventory();
      } catch (error) {
        this.$parent.$parent.sendSignalToInventory();
      }

    },
    changeSortDisplay(field, order) {
      let sort = this.displaySort;

      if (field == 'price') {
        if (order == 'asc')
          sort = 'Lowest Price';
        else
          sort = 'Highest Price';
      }
      else if (field == 'year') {
        if (order == 'asc')
          sort = 'Oldest vehicles';
        else
          sort = 'Newest inventory';
      }
      else if (field == 'mileage') {
        if (order == 'asc')
          sort = 'Lowest Mileage';
        else
          sort = 'Highest Mileage';
      }

      this.displaySort = sort;
    },
    sortBy(field, order) {
      this.changeSortDisplay(field, order);
      const pathname = window.location.pathname;
      const query = window.location.search || '';

      var a = pathname.replace(/\/?sort_order\/[a-zA-Z]+\//gi, '/');
      var b = a.replace(/\/?sort_by\/[a-zA-Z]+\//gi, '/');

      var url = '/sort_by/' + field + '/sort_order/' + order + '/';
      var finalUrl = b + url + query;
      history.replaceState({}, null, finalUrl.replace('//', '/'));
      this.sort = "";
      this.order = order;
      EventBus.$emit('sortInventory', { field, order });
      this.$parent.sendSignalToInventory();
    },
    display(component) {
      this.$emit('hideallcomponents', component);
      this.show = !this.show;
      this.$emit('update', {
        component,
        checked: this.checked,
      })
    },
    toggle(component) {
      this.$emit('setpivot', component);

      if (this.checked.length == 0) {
        this.$emit('unsetpivot', component);
      }
      this.$emit('updatechecked', {
        component,
        checked: this.checked,
      })
    },
  },
  watch: {
    checked() {
      if (this.checked.length > 0)
        this.displayName = this.checked.join(',');
      else
        this.displayName = this.title;
    },
    collapse(v) {
      this.show = v
    },
    items(currentVal) {
      if (currentVal.length == 1) {
        this.uniqueInList = currentVal[0];
        this.checked = [];
        this.checked.push(this.uniqueInList);
      } else if (!this.pivot) {
        this.checked = []
      }
    },
  },
  computed: {
    isResponsive() {
      return !this.disableResponsive == true;
    },
    displayName() {
      if (this.sort == '')
        return this.title;

      var desc = this.$t('high to low');
      var asc = this.$t('low to high');
      if (this.sort == 'Year') {
        desc = this.$t('newest to oldest');
        asc = this.$t('oldest to newest');
      }
      var sortTranslation = this.$t(this.sort.toLowerCase())
      var sortByCondition = { desc, asc };
      if (sortTranslation == "rebatesamount") {
        if (this.propTitle == "Sélectionner le type")
          sortTranslation = "Rabais";
        else
          sortTranslation = "Discount";
        if (this.sortCondition == "asc")
          this.sortCondition = "desc"
        else
          this.sortCondition = "asc";
        return `${sortTranslation}: ${sortByCondition[this.sortCondition]}`;
      }

      return `${sortTranslation}: ${sortByCondition[this.sortCondition]}`;
    }
  }
}
